export default "__VITE_ASSET__Q0YWJR0D__"